import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-select",
  "use": "icon-select-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-select\">\n<path d=\"M11.5 0.5H2.5C1.39543 0.5 0.5 1.39543 0.5 2.5V11.5C0.5 12.6046 1.39543 13.5 2.5 13.5H11.5C12.6046 13.5 13.5 12.6046 13.5 11.5V2.5C13.5 1.39543 12.6046 0.5 11.5 0.5Z\" stroke=\"#21a1f2\" />\n<path d=\"M12.1628 2.80798C8.99247 4.75294 6.69293 7.20891 5.65527 8.4395L3.12109 6.45283L2 7.35491L6.37486 11.808C7.12572 9.87867 9.5139 6.10868 12.4287 3.42849L12.1628 2.80798Z\" fill=\"#21a1f2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol